import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * TrailingSlashRedirect — client-side normalisation des trailing slashes.
 *
 * Redirige `/foo/` → `/foo` en préservant query string + hash. Utilise
 * `navigate(..., { replace: true })` pour ne pas polluer l'historique.
 *
 * ⚠️ Limitation SEO : sans contrôle du proxy Emergent, il s'agit d'une
 * redirection CLIENT — Google devra exécuter le JS. Pour du vrai 301 HTTP,
 * la plateforme Emergent doit ajouter une règle proxy `rewrite ^(.+)/$ $1
 * permanent;` (nginx) ou équivalent.
 */
const TrailingSlashRedirect = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;
    // Ignore la racine "/" et les paths sans slash final
    if (pathname !== '/' && pathname.endsWith('/')) {
      const cleaned = pathname.replace(/\/+$/, '') || '/';
      navigate(cleaned + search + hash, { replace: true });
    }
  }, [location, navigate]);

  return children;
};

export default TrailingSlashRedirect;
